import { useMemo, type ReactNode } from "react";
import { PaperFigure } from "./PaperFigure";
import { SheetWorld } from "./SheetWorld";
import { flat, lostPose, lostScene } from "./figures";
import "./public.css";

/*
  Where a public link leads nowhere (not found) or a public page fails (the
  route error): a vermilion strip cut free and lying loose on the bare sheet,
  the poster line beside it, and one way on. The strip arrives as the uncut
  sheet and springs loose, like every figure in this world; with reduced motion
  it is simply lying there.

  The wordmark and the actions come from the caller, because the two screens
  cannot use the same kind of link: the route error renders where the router
  itself has failed.
*/
export function Lost({
  mark,
  title,
  body,
  children,
}: {
  /** The wordmark, linking home. */
  mark: ReactNode;
  title: ReactNode;
  body: ReactNode;
  /** The one plate, and at most one text link beside it. */
  children: ReactNode;
}) {
  const pose = useMemo(() => lostPose(), []);
  const start = useMemo(() => flat(lostScene, pose), [pose]);
  return (
    <SheetWorld>
      <header className="sh-nav">{mark}</header>
      <main className="sh-lost sh-wrap">
        <div className="sh-lost__text">
          <h1 className="sh-lost__title">{title}</h1>
          <p className="sh-body sh-lost__body">{body}</p>
          <div className="sh-lost__actions">{children}</div>
        </div>
        <PaperFigure scene={lostScene} start={start} pose={pose} className="sh-lost__figure" />
      </main>
    </SheetWorld>
  );
}
